import { render, staticRenderFns } from "./LinkifiedText.vue?vue&type=template&id=225816c0"
import script from "./LinkifiedText.vue?vue&type=script&lang=js"
export * from "./LinkifiedText.vue?vue&type=script&lang=js"
import style0 from "./LinkifiedText.vue?vue&type=style&index=0&id=225816c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports